import React, { Suspense } from 'react';
var PDFReaderLazy = /*#__PURE__*/React.lazy(function () {
  return import('./index.lazy');
});
var PDFReader = function PDFReader(props) {
  var loader = props.loader;
  return /*#__PURE__*/React.createElement("div", {
    className: "PDFReader"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: loader
  }, /*#__PURE__*/React.createElement(PDFReaderLazy, props)));
};
export default PDFReader;